exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ingreso[data-v-341ac2c4]{margin:30px;border-radius:15px!important;border:0!important;width:250px;align-items:center;transition:.2s;z-index:0;cursor:pointer}.ingreso[data-v-341ac2c4]:hover{box-shadow:-1px 11px 16px 1px rgba(0,0,0,.32);transition:.2s;transform:scaleX(1.05) scaleY(1.05);z-index:1}.logo-inicio[data-v-341ac2c4]{display:block;padding-bottom:60px;max-width:600px;margin:auto}@media screen and (max-width:600px){.logo-inicio[data-v-341ac2c4]{width:80%;margin:20px}}#welcome[data-v-341ac2c4]{background:url(\"/public/images/site/background-welcome.svg\") no-repeat 50% 50%;background-color:#0cb9c9;display:table;height:100%;width:100%;background-position-y:bottom;background-size:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-341ac2c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/Thanks.vue
// module id = 610
// module chunks = 0